import React, { useEffect, useState } from "react";
import PageNav from "../components/PageNav";
import classNames from "classnames";
import { HomeworkSvg, Notes } from "../svg/svgs";
import useOnClick from "../components/common/ClosePopUp";
import axios from "axios";
// import loadingSpin from "../images/loadingSpin.gif";
import { animated, useSpring } from "react-spring";
import Card from "../components/common/Card";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AccordionMessage from "../components/AccordionMessage";

function Communication() {
  // const [loading, setLoading] = useState(false);
  const [communicate, setCommunicate] = useState([]);
  
  const Heading = () => (
    <>
      <span className="text-2xl leading-7 text-white mt-1">
        {" "}
        Communication{" "}
      </span>
    </>
  );
  const pageSvg = () => (
    <>
      <Notes />
    </>
  );

  const transitionStyles = useSpring({
    to: [{ opacity: 1, transform: "translateX(0)" }],
    from: { opacity: 0, transform: "translateX(80px)" },
    config: { duration: 700 },
  });

  return (
    <>
      <animated.div
        style={transitionStyles}
        className="px-4 sm:flex sm:-mt-2 sm:px-0"
      >
        <div className="w-full md:w-2/3 sm:pl-2">
          <PageNav Heading={Heading} PageSvg={pageSvg} />
          <div className="pt-6 w-full">
            {/* {loading ? (
              <div className="flex justify-center w-full h-full my-24">
                <img src={loadingSpin} alt="loading..." />
              </div>
            ) : ( */}
              <>
                <div className="mt-4">
                  <AccordionMessage />
                </div>
              </>
            {/* // )} */}
          </div>
        </div>
      </animated.div>
    </>
  );
}

export default Communication;
